export default __webpack_public_path__ + "static/media/doobi_yellow_large.a88894bf.png";